var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('label',{staticClass:"ts-mb-0"},[_vm._v(_vm._s(_vm.$t('productProfile.branchList')))]),_c('a-select',{staticClass:"ts-w-full",attrs:{"mode":"multiple","options":_vm.branchList,"filterOption":(input, option) =>
            option.componentOptions.children[0].text
              .toLowerCase()
              .indexOf(input.toLowerCase()) >= 0,"maxTagCount":5},model:{value:(_vm.model.other_branch_list),callback:function ($$v) {_vm.$set(_vm.model, "other_branch_list", $$v)},expression:"model.other_branch_list"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }